export default {
    scheme: 'pico',
    author: 'PICO-8 (http://www.lexaloffle.com/pico-8.php)',
    base00: '#000000',
    base01: '#1d2b53',
    base02: '#7e2553',
    base03: '#008751',
    base04: '#ab5236',
    base05: '#5f574f',
    base06: '#c2c3c7',
    base07: '#fff1e8',
    base08: '#ff004d',
    base09: '#ffa300',
    base0A: '#fff024',
    base0B: '#00e756',
    base0C: '#29adff',
    base0D: '#83769c',
    base0E: '#ff77a8',
    base0F: '#ffccaa',
};
